import { useRouter } from 'next/router';
import React, { useState, useEffect } from 'react';
import Link from 'next/link';

function Dropdown (props, sectionCode, categoryCode) {
  const [open, setOpen] = useState(false);
  const [item, setItem] = useState(null);
  const router = useRouter();
  const [firstCategoryCodeText, setFirstCategoryCodeText] = useState('');

  const selectItem = (item) => {
    if (typeof props.onChange === 'function') {
      props.onChange(item);
    }
    setItem(item);
  };

  useEffect(() => {
    props.data.map((item, index) => {
      if (item.code === props.categoryCode) {
        setFirstCategoryCodeText(item.text);
      }
    });
  }, []);

  return (
    <>
      <div className={`category_linkselect_w ${open ? 'current' : ''}`} onClick={() => setOpen(!open)} onMouseLeave={() => setOpen(false)}>
        <h3 className='cl_title' id='dropdown-box'>
          <a
            className='cl_link' role='button' aria-labelledby={(item) ? item.text : props.data[0].text} aria-expanded={`${open ? 'true' : 'false'}`}
            href='#'
          >
            <span className='cl_link_text'>{(item) ? item.text : firstCategoryCodeText}</span>
            <i className='category_icon_arrow'>
              <svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'>
                <path className='a' d='M11.189,13.055l3.781,3.971a.688.688,0,0,0,1.009,0,.783.783,0,0,0,0-1.062l-4.284-4.5a.689.689,0,0,0-.985-.022L6.4,15.961a.781.781,0,0,0,0,1.062.688.688,0,0,0,1.009,0Z' transform='translate(-6.188 -11.246)' />
              </svg>
            </i>
          </a>
        </h3>
        <div className='category_linkselect_inner'>
          <ul className='cl_list' role='listbox' aria-labelledby='dropdown-box'>
            {props.data.map((item, index) => {
              const linkUrl = item.link?.outUrl
                ? { pathname: item.link.outUrl }
                : { pathname: router.pathname, query: { ...router.query, ...item?.link?.query } };
              const isNewTabOpen = !!item.link?.outUrl;

              return (
                <li
                  key={`dropdown_item_${index}`} role='option' className='cll_inner'
                  onClick={() => selectItem(item)}
                  onKeyUp={(event) => {
                    if (event.keyCode === 13) {
                      selectItem(item);
                    }
                  }}
                >
                  {isNewTabOpen
                    ? <a className='cll_link' href='#'>{item.text}</a>
                    : (
                      <Link href={linkUrl}>
                        <a className='cll_link' href='#' style={{ display: open ? '' : 'none' }}>{item.text}</a>
                      </Link>
                      )}
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </>
  );
}

export default Dropdown;
